export const columns = [
  {
    Header: "Разработчики",
    accessor: "name"
  },
  {
    Header: "Стек",
    accessor: "stack",
    filter: "byTags"
  },
  {
    Header: "Опыт, лет",
    accessor: "exp"
  },
  {
    Header: "Cвободен",
    accessor: "date"
  },
  {
    Header: "Текущая загрузка",
    accessor: "busy",
    filter: "byBusy"
  },

  {
    Header: "Ставка в час",
    accessor: "rate"
  },
  {
    Header: "Бронирование",
    accessor: "booking"
  }
];
